module.exports = __webpack_public_path__ + "static/img/user.1f00823.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user.png
// module id = 8tHC
// module chunks = 3